export const environment = {
  production: false,
  // No Encryption api
  apiUrl: 'https://posapi.telefonak.com/api',
  hubUrl: 'https://posapi.telefonak.com/hubs/',
  
  // Encryption api //[IMPORTANT] THIS ENCRYPTION DOES NOT WORK WITH FORMDATA so for now disabled
  // apiUrl: 'https://encryption.telefonak.com/api',
  // hubUrl: 'https://encryption.telefonak.com/hubs',
  enableEncryption:false,
  
  apiUrl2: 'https://datacompare.telefonak.com/api',
  // Live
  // apiUrl: 'https://api.atc-pos.com/api',
  // hubUrl: 'https://api.atc-pos.com/hubs/',
  tokenName: "HalaAuthToken",
  userDataName: "ThisUserAllData",
  deviceId: "HalaDeviceId",
  encryptionKeyString:"YourSecretKey123",
  encryptionIVString:"YourIV1234567890",

};